import React from 'react';
import classNames from 'classnames';

const WidgetActions = ({ currentStep, setCurrentStep, totalSteps }) => {
    const prevStep = (e) => {
        e.preventDefault();
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
        }
    };

    const nextStep = (e) => {
        e.preventDefault();
        // Allow navigation up to the final step (the submit form)
        if (currentStep < totalSteps) {
            setCurrentStep(currentStep + 1);
        }
    };

        return (
        <div className="widget__actions">
            <button 
                className={classNames('btn btn--prev')}
                onClick={prevStep} 
                disabled={currentStep === 0}
            >
                Previous
            </button>
            
            {/* The 'Next' button is shown during the configuration steps */}
            {currentStep < totalSteps - 1 && (
                <button 
                    className={classNames('btn btn--next')} 
                    onClick={nextStep}
                >
                    Next
                </button>
            )}

            {/* The 'Submit' button is shown on the last configuration step */}
            {currentStep === totalSteps - 1 && (
                <button 
                    className={classNames('btn btn--submit')} 
                    onClick={nextStep}
                >
                    Submit
                </button>
            )}
        </div>
    );
};

export default WidgetActions;


